module.exports = __webpack_public_path__ + "static/biz-lpg-d228e539a845d060dcd9c3181dfda4cd.jpg";